import { gql } from '@apollo/client';
import { QUOTE_FRAGMENT } from '../queries/quote';

export const CREATE_QUOTE = gql`
  ${QUOTE_FRAGMENT}
  mutation CreateQuote($input: QuoteInput!) {
    createQuote(input: $input) {
      ...QuoteFields
    }
  }
`;

export const UPDATE_QUOTE = gql`
  ${QUOTE_FRAGMENT}
  mutation UpdateQuote($id: Int!, $input: QuoteInput!) {
    updateQuote(id: $id, input: $input) {
      ...QuoteFields
    }
  }
`;

export const DELETE_QUOTE = gql`
  mutation DeleteQuote($id: Int!) {
    deleteQuote(id: $id)
  }
`;

export const SEND_QUOTE = gql`
  ${QUOTE_FRAGMENT}
  mutation SendQuote($id: Int!) {
    sendQuote(id: $id) {
      ...QuoteFields
    }
  }
`;

export const SEND_QUOTE_BY_CHANNELS = gql`
  ${QUOTE_FRAGMENT}
  mutation SendQuoteByChannels($id: Int!, $channels: [QuoteSendChannel!]!) {
    sendQuoteByChannels(id: $id, channels: $channels) {
      quote {
        ...QuoteFields
      }
      results {
        channel
        success
        error
      }
    }
  }
`;

export const ACCEPT_QUOTE = gql`
  ${QUOTE_FRAGMENT}
  mutation AcceptQuote($id: Int!) {
    acceptQuote(id: $id) {
      ...QuoteFields
    }
  }
`;

export const REJECT_QUOTE = gql`
  ${QUOTE_FRAGMENT}
  mutation RejectQuote($id: Int!) {
    rejectQuote(id: $id) {
      ...QuoteFields
    }
  }
`;

export const DUPLICATE_QUOTE = gql`
  ${QUOTE_FRAGMENT}
  mutation DuplicateQuote($id: Int!) {
    duplicateQuote(id: $id) {
      ...QuoteFields
    }
  }
`;

export const CONVERT_QUOTE_TO_BOOKING = gql`
  mutation ConvertQuoteToBooking($id: Int!, $packageId: Int, $formulaId: Int) {
    convertQuoteToBooking(id: $id, packageId: $packageId, formulaId: $formulaId) {
      id
      status
      totalPrice
    }
  }
`;
